export const SHARED_ITEM_NOTICE =
  'Shared with other family members. Only the figures held against this client can be changed ' +
  'here — open the item on the family Cashflows tab to change the rest.';

/**
 * An individual client's tab reads only that client's rows, so it holds part of a shared item and
 * cannot tell who else is in the group. Editing the parts that every row carries — who it applies
 * to, and the description, type and frequency copied onto each of them — would either double a
 * member up or leave the group's rows disagreeing, so those are read-only there. The whole item is
 * editable on the family tab, which reads every member.
 */
export function isPartOfAGroup(items: { groupId?: string | null }[] | undefined): boolean {
  return Boolean(items?.some(item => item.groupId));
}
